import { render } from "./CourseDetails.vue?vue&type=template&id=004d570f&ts=true"
import script from "./CourseDetails.vue?vue&type=script&lang=ts"
export * from "./CourseDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__